// extracted by mini-css-extract-plugin
export default {"content":"uL","wrapper":"vL","gif":"wL","textContent":"xL","gifContainer":"yL","proteinGif":"zL","counter_img":"AL","usage-container":"BL","usage-list":"CL","checklist":"EL","counter_title":"FL","counter_wrapper":"GL","active":"HL","usage-counter":"IL","line":"JL"};
    if(module.hot) {
      // 1713809678601
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  